import React from 'react'
import PropTypes from 'prop-types'
import { IconFAWrapper } from './IconFAWrapper'

export const IconFAHalfHourglass = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg
        aria-hidden='true'
        focusable='false'
        data-prefix='fas'
        data-icon='times'
        role='img'
        viewBox='0 0 12 14'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          d='M11.498 0.999999H12.248C12.3887 0.999999 12.498 0.890624 12.498 0.75V0.25C12.498 0.109375 12.3887 -9.53674e-07 12.248 -9.53674e-07H0.748047C0.607422 -9.53674e-07 0.498047 0.109375 0.498047 0.25V0.75C0.498047 0.890624 0.607422 0.999999 0.748047 0.999999H1.49805C1.49805 3.89062 2.88086 5.98437 4.41211 7C2.88086 8.01562 1.49805 10.1094 1.49805 13H0.748047C0.607422 13 0.498047 13.1094 0.498047 13.25V13.75C0.498047 13.8906 0.607422 14 0.748047 14H12.248C12.3887 14 12.498 13.8906 12.498 13.75V13.25C12.498 13.1094 12.3887 13 12.248 13H11.498C11.498 10.1094 10.1152 8.01562 8.58398 7C10.1152 5.98437 11.498 3.89062 11.498 0.999999ZM10.498 0.999999C10.498 2.14062 10.2402 3.14844 9.83398 4H3.16211C2.75586 3.14844 2.49805 2.14062 2.49805 0.999999H10.498ZM10.0527 10.5H2.94336C3.52148 8.99219 4.56055 7.92187 5.59961 7.5H7.39648C8.43555 7.92187 9.47461 8.99219 10.0527 10.5Z'
        />
      </svg>
    </IconFAWrapper>
  )
}

IconFAHalfHourglass.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
